import { render, staticRenderFns } from "./ServiceColumn.vue?vue&type=template&id=c3995820&scoped=true&"
import script from "./ServiceColumn.vue?vue&type=script&lang=js&"
export * from "./ServiceColumn.vue?vue&type=script&lang=js&"
import style0 from "./ServiceColumn.vue?vue&type=style&index=0&id=c3995820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3995820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemContent})
